import { Logo } from "./Logo";
import { CONTACT_EMAIL } from "./config";

export const Footer = () => (
  <footer
    data-testid="footer"
    className="border-t border-white/10 bg-[#080808] py-16"
  >
    <div className="mx-auto flex max-w-7xl flex-col items-center gap-8 px-6 text-center">
      <div className="flex items-center gap-3">
        <Logo size={32} />
        <span className="font-accent text-base font-bold tracking-[0.25em] text-[#EAEAEA]">
          IRONCREST
        </span>
      </div>
      <nav className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
        <a
          href="/api/privacy"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-privacy-link"
          className="text-sm text-[#A3A3A3] transition-colors duration-300 hover:text-[#D4AF37]"
        >
          Privacy Policy
        </a>
        <a
          href="/api/account/delete-request"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-delete-link"
          className="text-sm text-[#A3A3A3] transition-colors duration-300 hover:text-[#D4AF37]"
        >
          Account Deletion
        </a>
        <a
          href={`mailto:${CONTACT_EMAIL}`}
          data-testid="footer-contact-link"
          className="text-sm text-[#A3A3A3] transition-colors duration-300 hover:text-[#D4AF37]"
        >
          Contact
        </a>
      </nav>
      <p className="text-sm text-[#737373]">
        Contact:{" "}
        <a
          href={`mailto:${CONTACT_EMAIL}`}
          className="font-semibold text-[#A3A3A3] transition-colors duration-300 hover:text-[#D4AF37]"
        >
          {CONTACT_EMAIL}
        </a>
      </p>
      <p className="text-xs text-[#737373]">
        &copy; 2026 Ironcrest. All rights reserved.
      </p>
    </div>
  </footer>
);
